export default defineNuxtPlugin(() => {
  const { initSounds } = useAudio();
  initSounds();
});
